import { useEffect, useState } from "react";
import axios from "axios";
import { useCache } from "./cacheProvider";
import api from "../interceptor/api";
import { useLoading } from "./context/LoadingProvider";

export default function useFetch({
  key,
  initialEnabled = true,
  cache,
  ...axiosConfig
}) {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const {getCache, setCache } = useCache();
  const {showLoader, hideLoader}=useLoading();
  const [apiCount,setAPICount]=useState(0);
  
  useEffect(() => {
    if (initialEnabled) refetch();
  },[]);

  /**
   * this function checks if data is present is chache or not if not , then makes an API cal
   */
  const refetch = (hard = false) => {
    setError(undefined);
    const cacheKey = (key);
    if (cache?.enabled && getCache(cacheKey) && !hard) {
      setData(getCache(cacheKey));
      setError(undefined);
      return;
    }
    showLoader();
    api.request(axiosConfig)
      .then((data) => {
        let count=apiCount
        setAPICount(count++);
        setData(JSON.parse(data?.data?.packageHtml));
        if (cache?.enabled) setCache(cacheKey, JSON.parse(data?.data?.packageHtml), cache?.ttl);
      })
      .catch((err) => {
        hideLoader();
        setError(err);
      })
      .finally(() => {
        let count = apiCount;
        if (count > 0) count--;
        if (!count) {  hideLoader() }
        setAPICount(count--);
      })
  };
  
  return { data, error, refetch };
}